<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" title="修改密码" width="400px" @open='opened'>
            <el-form :model="form" label-width="80px" label-position="left">
                <el-form-item label="原密码" class="is-required" v-if="isSelf">
                    <el-input placeholder="请输入原密码" v-model="form.old_password" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码" class="is-required">
                    <el-input placeholder="请输入新密码" v-model="form.new_password" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码" class="is-required">
                    <el-input placeholder="再次输入新密码" v-model="form.again_passwoerd" show-password></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align:right;">
                <el-button type="danger" @click="dialogVisible=false" size="mini">取消</el-button>
                <el-button type="primary" @click="confirm" size="mini">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {changePassword} from '@/api/user'
export default {
    props: {
        isShow: {
            // 弹窗是否展示
            type: Boolean,
            default: false,
        },
        isSelf:{
            type: Boolean,
            default: false,
        },
        staff_id:{},
    },
    data() {
        return {
            form:{
                old_password:'',
                new_password:'',
                again_passwoerd:''
            }
        };
    },
    computed: {
        dialogVisible: {
            get() {
                return this.isShow;
            },
            set(val) {
                this.$emit("update:isShow", false);
            },
        },
    },
    created() {},
    mounted() {},
    methods: {
        async confirm(){
            if(this.isSelf && !this.form.old_password) return this.$message.warning('原密码不能为空')
            if(!this.form.new_password) return this.$message.warning('请输入新密码')
            if(this.form.new_password != this.form.again_passwoerd) return this.$message.warning('新旧密码不一致')
            const res = await changePassword({
                staff_id:this.staff_id,
                old_password:this.isSelf?this.form.old_password:void 0,
                new_password:this.form.new_password,
            })
            if(res.code == 200 ){
                if(this.isSelf){
                    this.$message.success('修改成功,请重新登录')
                    await this.$store.dispatch('user/logout')
                    this.$router.push('/login')
                }else{
                    this.$message.success('修改成功')
                    this.$emit('init')
                }
                
            }else{
                this.$message.warning('修改失败')
            }
            this.dialogVisible = false
        },
        opened(){
            this.form = {
                old_password:'',
                new_password:'',
                again_passwoerd:''
            }
        }
    },
};
</script>
<style scoped lang='scss'>
</style>